import React from 'react';
import { connect } from 'react-redux';
import config from "config";
import Path from "components/common/path";
import NodeDropdown from "components/common/dropdowncomponents/nodedropdown";
import ListDropdown from "components/common/dropdowncomponents/listdropdown";
import ColorNote from "components/common/colornote";
import LiveSummary from "./summary";
import FloorPlan from "./floorplan";
import LiveStatsMenuItems from 'components/common/livestatsmenuitems';
import {
	selectNodeFilter,
	selectViewFilter
} from "actions/live/filter"
import {
	fetchLiveData
} from 'actions/node';
import StickyMenu from "components/common/stickymenu"
import StatsMenu from "components/common/statsmenu"
class Live extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			currentNode: {
				info: {
					name: "",
					empty: true
				},
				children: [],
				type: null
			},
			path: [],
			showDetails: true,
			I: {}
		};
	}

	fetchLive() {
		this.props.dispatch(fetchLiveData());

	}

	componentDidMount() {
		this.prepare(this.props);
		var I = setInterval(this.fetchLive.bind(this), 5000);
		this.setState({ I: I });

	}
	componentWillUnmount() {
		clearInterval(this.state.I);
	}

	empty(node) {
		return (node.info.empty == true)
	}

	componentWillReceiveProps(nextProps) {
		this.prepare(nextProps);
	}

	prepare(props) {
		var path = [];
		var res = { currentNode: {} };
		this.findNode(props.nodeMap, props.params.id, path, res);
		this.setState({ currentNode: res.currentNode, path: path });

		var oldnode = this.state.currentNode;
		var currentNode = res.currentNode;

		var cond1 = (oldnode.id != currentNode.id && !this.empty(currentNode));
		var cond2 = (props.nodeFilter.info.empty && !this.empty(currentNode));
		var cond3 = (oldnode.id == currentNode.id && oldnode.children.length != currentNode.children.length);
		// console.log(oldnode, currentNode, cond1, cond2);
		if (cond1 || cond2 || cond3) {
			// either floor changed or no node filter yet => set node filter to all areas.
			this.props.dispatch(selectNodeFilter(currentNode));
		}
		if (currentNode.type == config.room.MEETINGROOM.code || props.nodeFilter.type == config.room.MEETINGROOM.code || props.viewFilter == config.viewFilter.MAINTENANCE) {
			this.setState({
				showDetails: true
			})
		}
	}

	findNode(nodeMap, id, path, res) {
		res.currentNode = nodeMap[id]
		if (!res.currentNode) {
			res.currentNode = {};
			return;
		}
		var tmp = [], cur = res.currentNode;
		while (cur) {
			tmp.push(cur);
			cur = cur.parent;
		}
		while (tmp.length) {
			path.push(tmp[tmp.length - 1]);
			tmp.pop();
		}
	}

	changeMRMode() {
		this.setState({
			showDetails: !this.state.showDetails
		});
	}

	listNodeFilter(root, res) {
		var self = this;
		if (root) {
			if (root.type == config.room.MEETINGROOM.code || root.type == config.room.OPENAREA.code) {
				res.push(root);
			}
			if (root.children) {
				root.children.forEach((child) => {
					self.listNodeFilter(child, res);
				})
			}
		}
	}
	render() {
		return (
			<div className="live-page overwrite--modal--depth">
				<StickyMenu
					withStickyHeader={false}
				>
					<StatsMenu
						leftItemBold={this.state.currentNode.info.name}
						leftItems={
							<LiveStatsMenuItems
								id={this.state.currentNode.id}
								node={this.state.currentNode}
							/>
						}
					/>

					<Path path={this.state.path} linkOn={(x) => x.info.hasfloorplan} link={(x) => "live/" + x.id} />

				</StickyMenu>

				<div className="page-content">

					<div>
						<ColorNote mode={"sensors"} />
						<FloorPlan
							changeMRMode={() => { this.changeMRMode() }}
							root={this.props.nodeMap[this.props.nodeFilter.id]}
							viewFilter={this.props.viewFilter}
							showDetails={this.state.showDetails}
							tooltipGroup="index"
							thumbnail={false}
							currentNode={this.state.currentNode}
						>
							<ListDropdown
								outsideClass="view-filter"
								items={config.viewFilter}
								getText={(x) => x.text}
								selected={this.props.viewFilter}
								click={(view) => { this.props.dispatch(selectViewFilter(view)) }}
							/>

							<NodeDropdown
								outsideClass="view-filter"
								root={this.state.currentNode}
								nodeFilter={this.props.nodeFilter}
								click={
									(node) => { this.props.dispatch(selectNodeFilter(node)) }
								}
								list={this.listNodeFilter.bind(this)}
								header="All areas"
							/>

						</FloorPlan>
						<LiveSummary
							root={this.state.currentNode}
							sensorMap={this.props.sensorMap}
						/>
					</div>
				</div>
			</div >
		);
	}
}

function mapStateToProps(state) {
	return {
		nodeMap: state.overviewReducer.nodeMap,
		nodeFilter: state.liveReducer.nodeFilter,
		viewFilter: state.liveReducer.viewFilter,
		sensorMap: state.nodeReducer.map
	};
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Live);


// WEBPACK FOOTER //
// ./src/components/pages/live/index.jsx